import PaypalLogo from 'components/assets/paypal_logo.svg';
import MobiWorkXIcon from 'components/assets/mobiworkx-icon.svg';
import A from 'components/atoms/A/A';
import Card from 'components/atoms/Card/Card';
import Txt from 'components/atoms/Txt/Txt';
import Image from 'next/image';
import { RedemptionTypeKey } from '../../pages/RewardOptions/__generated__/RewardOptionsQuery.graphql';
import classes from './RedemptionOptionItem.module.scss';
import { useRedemptionOptionItemQuery } from './useRedemptionOptionItem';
import { useRedemptionOptionItemQuery_optionRef$key } from './__generated__/useRedemptionOptionItemQuery_optionRef.graphql';

export interface Props {
  optionRef: useRedemptionOptionItemQuery_optionRef$key;
  redemptionType: RedemptionTypeKey;
}

export default function RedemptionOptionItem({ optionRef, redemptionType }: Props) {
  const option = useRedemptionOptionItemQuery(optionRef);

  return (
    <li className={classes.root}>
      <Card isLink className={classes.card}>
        <A href={`/redeem/${redemptionType}/${option.key}`} className={classes.link}>
          {option.imageUrl && option.imageUrl.trim() !== '' ? (
            <div className={classes.imageContainer}>
              <Image
                src={option.imageUrl}
                alt={option.name}
                width={256}
                height={160}
                className={classes.image}
              />
            </div>
          ) : redemptionType === 'PAYPAL' ? (
            <div className={classes.paypalIcon}>
              <PaypalLogo />
            </div>
          ) : (
            <div className={classes.fallbackIcon}>
              <MobiWorkXIcon />
            </div>
          )}
          <Txt skipTranslation className={classes.label}>
            {option.name}
          </Txt>
        </A>
      </Card>
    </li>
  );
}
